interface BadgeProps {
  count?: number;
  tone?: 'red' | 'amber' | 'blue';
}

export function Badge({ count, tone = 'red' }: BadgeProps) {
  if (!count) return null;
  return (
    <span className={`badge badge-${tone}`}>{count}</span>
  );
}
